module.exports = __webpack_public_path__ + "img/ext-03.b50c3052.jpg";